const INITIAL_STATE = {
  lancamentos_financeiros: [],
  pagination: null,
  conta: null,
  cadastro: {
    competencia: new Date(),
    vencimento: new Date(),
    ultimoPagamento: new Date(),
    dataNf: new Date(),
    pagamento: {
      label: "",
      value: 0,
    },
    parcela: null,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "CONTAS_FETCH":
      return { ...state, lancamentos_financeiros: action.payload };
    case "CONTA_FETCH":
      return { ...state, conta: action.payload };
    case "CONTA_EDITAR_FETCH":
      return { ...state, cadastro: action.payload };
    case "CONTAS_PAGINATION":
      return { ...state, pagination: action.payload };
    default:
      return state;
  }
};
